import { render, staticRenderFns } from "./BadgeOrigem.vue?vue&type=template&id=0683ccb6&scoped=true&lang=pug"
import script from "./BadgeOrigem.vue?vue&type=script&lang=js"
export * from "./BadgeOrigem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0683ccb6",
  null
  
)

export default component.exports